export const MODEL_TRAVEL_BY_PLANE = "plane"
export const MODEL_TRAVEL_BY_TRAIN = "train"
export const MODEL_TRAVEL_BY_CAR = "car"
export const MODEL_TRAVEL_BY_TAXI = "taxi"
export const MODEL_TRAVEL_BY_BOAT = "boat"
export const MODEL_TRAVEL_BY_OTHER = "other"
